import axiosInstance from 'utils/axiosInstance';
import { Notifications, Reminder } from '../types/types';

export const GetReminderList = async (userId: string) => {
  const { data } = await axiosInstance.get<ApiResponse<Reminder[]>>(
    `api/Reminder/GetList/${userId}`,
  );
  return data;
};

export const CreateReminders = async (reminder: Reminder) => {
  const { data } = await axiosInstance.post<ApiResponse<string>>(
    'api/Reminder/Create',
    reminder,
  );
  return data;
};

export const UpdateReminders = async (reminder: Reminder) => {
  const { data } = await axiosInstance.post<ApiResponse<string>>(
    'api/Reminder/Edit',
    reminder,
  );
  return data;
};

export const DeleteReminder = async (id: number) => {
  const { data } = await axiosInstance.delete<ApiResponse<string>>(
    `api/Reminder/Delete/${id}`,
  );
  return data;
};

export const GetReminderById = async (id: number) => {
  const { data } = await axiosInstance.get<ApiResponse<Reminder>>(
    `api/Reminder/GetById/${id}`,
  );
  return data;
};

export const GetNotifications = async () => {
  const { data } = await axiosInstance.get<Notifications[]>(
    'api/Reminder/GetNotifications',
  );
  return data;
};

export const MarkAllAsReadNotifications = async () => {
  const { data } = await axiosInstance.get<ApiResponse<string>>(
    'api/Reminder/MarkAsReadNotifications',
  );
  return data;
};

export const MarkAsReadNotification = async (id: number) => {
  const { data } = await axiosInstance.get<ApiResponse<string>>(
    `api/Reminder/MarkAsReadNotification/${id}`,
  );
  return data;
};
